import adapter from './adapter'
import { collectionMutations } from '@/store/collection'
import { paginationMutations } from '@/store/pagination'

const { upsertMany, upsertOne, removeOne } = collectionMutations(adapter)
const { updatePagination, resetPagination } = paginationMutations()

export default {
  upsertMany,
  upsertOne,
  removeOne,
  updatePagination,
  resetPagination,
  setResume(state, payload) {
    state.resume = payload;
  },
  setResumeByMonth(state, payload) {
    state.resumeByMonth = payload;
  },
}
